import React from 'react';
import { ICollection, IContent } from 'types';
import { Swiper, SwiperSlide } from 'swiper/react';
import CollectionTitle from './CollectionTitle';

interface Props {
  collection: ICollection;
}

function DefaultCollection({ collection }: Props) {
  return (
    <div css={{ paddingLeft: '16px' }}>
      <CollectionTitle title={collection.title} />
      <Swiper
        spaceBetween={16}
        slidesPerView="auto"
        css={{
          '.swiper-slide': {
            width: '200px',
          },
        }}
      >
        {collection.contents?.map((c) => {
          const { id } = c as IContent;
          return (
            <SwiperSlide key={id}>
              <DefaultCollectionItem content={c as IContent} />
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
}

function DefaultCollectionItem({ content }: { content: IContent }) {
  return (
    <div
      css={{
        width: '200px',
      }}
    >
      <img
        src={content.thumbnailUrl}
        alt=""
        css={{ width: '100%', borderRadius: '8px' }}
      />
      <p
        css={{
          fontSize: '14px',
          lineHeight: '18px',
          margin: '4px 0',
          wordBreak: 'keep-all',
          height: '50px',
        }}
      >
        {content.title}
      </p>
    </div>
  );
}

export default DefaultCollection;
